module.exports = __webpack_public_path__ + "img/SqualoSport-interno7.a1099531.jpeg";